/** External Consent Agreement PDF (opens in a new tab). */
export const CONSENT_AGREEMENT_PDF_URL = {
  en: 'https://ship.purolator.com/assets/document/purolator-consent-agreement-credit-cards_en.pdf',
  fr: 'https://ship.purolator.com/assets/document/purolator-consent-agreement-credit-cards_fr.pdf',
} as const;

/** Printable Terms and Conditions PDF linked from the T&C modal. */
export const TERMS_AND_CONDITIONS_PDF_URL = {
  en: 'https://www.purolator.com/en/media/5541/download',
  fr: 'https://www.purolator.com/fr/media/5546/download',
} as const;

/** Bundled modal body content (ported from ESN). */
export const TERMS_CONTENT_ASSET_URL = {
  en: 'assets/documents/terms/terms-en.json',
  fr: 'assets/documents/terms/terms-fr.json',
} as const;
